import {TransferCreditType} from "types/transferCredits"

export type TransferCreditUiField =
    | "termNameTransfer"
    | "courseNameTransfer"
    | "creditsTransfer"
    | "alphabetical"
    | "grades"
    | "qualityPoints"
    | "idEquivalent"
    | "nameEquivalent"
    | "gradeEquivalent"
    | "creditsEquivalent"
    | "appliedCredits"
    | "university"
    | "programNameTransfer"

export const isHoursType = (typeId?: TransferCreditType | null) => typeId === TransferCreditType.Hours

export const getTypeId = (
    typeValue?: {id?: TransferCreditType} | TransferCreditType | null
): TransferCreditType | null => {
    if (!typeValue) return null
    if (typeof typeValue === "string") return typeValue
    return typeValue.id ?? null
}

/** Credits (or unset) keeps current columns. Other types hide/show per field. */
export const isFieldVisible = (
    typeId: TransferCreditType | null | undefined,
    field: TransferCreditUiField
): boolean => {
    const type = typeId ?? TransferCreditType.Credits

    switch (field) {
        case "termNameTransfer":
            return type === TransferCreditType.Credits || type === TransferCreditType.TheoryHours
        case "courseNameTransfer":
            return type !== TransferCreditType.Hours
        case "creditsTransfer":
            return type !== TransferCreditType.Grade
        case "alphabetical":
            return type !== TransferCreditType.TheoryHours
        case "grades":
            return type === TransferCreditType.Credits || type === TransferCreditType.Practical
        case "qualityPoints":
            return type === TransferCreditType.Credits || type === TransferCreditType.Practical
        case "gradeEquivalent":
            return type === TransferCreditType.Practical || type === TransferCreditType.Grade
        default:
            return true
    }
}
